jQuery(document).ready(function() {
  // Your custom code...

  console.log("File successfully loaded!");
});

// jQuery(window).load(function() {
//   var windowSize = screen.width;
//   if (windowSize > 1024) {
//     var colInfoContactHeight = jQuery(".col-info-contact").height();
//     jQuery(".col-form .contact-form-custom .wpb_wrapper").css(
//       "min-height",
//       colInfoContactHeight - 262 + "px"
//     );
//   }
// });

(function($) {
  function showCountries(e) {
    e.preventDefault();
    var x = document.querySelector(".arrow-box");
    var menu = document.querySelector(".overlay-menu-country");
    console.log(x.style.display);
    if (x.style.display == "") {
      x.style.display = "block";
      menu.style.display = "block";
      menu.style.zIndex = "1000";
    } else if (x.style.display == "none") {
      x.style.display = "block";
      menu.style.display = "block";
      menu.style.zIndex = "1000";
    } else {
      x.style.display = "none";
      menu.style.display = "none";
      menu.style.zIndex = "-1";
    }
  }
  function goCountry() {
    var countryURL = document.querySelector("#get-country-select").value;
    window.open(countryURL);
  }

  function hideModalCountry() {
    var menu = document.querySelector(".overlay-menu-country");
    var x = document.querySelector(".arrow-box");
    console.log(menu.style.display);
    if (menu.style.display == "") {
      menu.style.display = "block";
      x.style.display = "block";
      menu.style.zIndex = "1000";
    } else if (menu.style.display == "none") {
      menu.style.display = "block";
      x.style.display = "block";
      menu.style.zIndex = "1000";
    } else {
      menu.style.display = "none";
      x.style.display = "none";
      menu.style.zIndex = "-1";
    }
  }
  window.showCountries = showCountries; //export function sample to the globals.
  window.goCountry = goCountry; //export function sample to the globals.
  window.hideModalCountry = hideModalCountry; //export function sample to the globals.
})(jQuery);
